"use client"

import * as React from "react"
import {ChevronLeftIcon, ChevronRightIcon} from "lucide-react"
import {DayPicker, UI} from "react-day-picker"

import {cn} from "@/lib/utils"

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({
                      className,
                      classNames,
                      showOutsideDays = true,
                      ...props
                  }: CalendarProps) {
    return (
        <DayPicker
            showOutsideDays={showOutsideDays}
            className={cn("p-3", className)}
            classNames={{
                [UI.Root]: "space-y-4",
                [UI.Month]: "space-y-4",
                [UI.CaptionLabel]: "flex w-full justify-center",
                [UI.Nav]: "flex items-center justify-between space-x-1",
                [UI.Weekdays]: "flex justify-between text-xs font-medium text-muted-foreground",
                [UI.Weekday]: "flex justify-center w-9 h-9 text-center",
                [UI.Weeks]: "space-y-1",
                [UI.Week]: "flex justify-between",
                [UI.Day]: "flex justify-center items-center h-9 w-9 rounded-full transition-colors",
                [UI.DayButton]: cn(
                    "h-9 w-9 rounded-full text-center transition-colors",
                    "aria-selected:bg-primary aria-selected:text-primary-foreground hover:bg-muted"
                ),
                [UI.Dropdowns]: "flex items-center space-x-2",
                [UI.Dropdown]: "p-2 rounded border border-muted bg-background text-sm",
                [UI.Footer]: "flex justify-center mt-4",
                ...classNames,
            }}
            components={{
                Chevron: (props) => {
                    if (props.orientation === "left") {
                        return <ChevronLeftIcon {...props} />;
                    }
                    return <ChevronRightIcon {...props} />;
                }
            }}
            {...props}
        />
    )
}

Calendar.displayName = "Calendar"

export {Calendar}
